import { useRef } from 'react';
import Portada from './Portada';
import Introduccion from './Introduccion';
import MenuPrincipal from './MenuPrincipal';
import Header from '../globales/Header';

const Inicio = () => {
  const refIntroduccion = useRef(null);
  const refIndice = useRef(null);

  return (
    <div>
      <div className="overflow-hidden ">{/* //z-index: 2 */}
        <Portada elementoIntroduccion={refIntroduccion} />
      </div>
      <div className="relative" ref={refIntroduccion}>
        <div className="hidden sticky top-0 w-full z-50 h-28 lg:flex ">
          <Header />
        </div>

        <div className="lg:-mt-28" >{/* //z-index: 1 */}
          <Introduccion indice={refIndice} />
        </div>
        <div ref={refIndice}>{/* //z-index: 0 */}
          <MenuPrincipal />
        </div>
      </div>
    </div>
  )
}

export default Inicio;